import { Component, Element, h, Prop, State } from '@stencil/core';
import { initShadowMountPoints } from '../../../utils/utils';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rtr-stripe-express-checkout',
  styleUrl: 'style.sass',
  shadow: true,
})

export class RtrStripeExpressCheckout {
  @Prop() stripe: any;
  @Prop() method: string;
  @Prop() amountToPay!: number;
  @Prop() currency: string;

  @Prop() onConfirm: (method: string, elements: any) => void;
  @Prop() onClose: () => void;
  @State() isLoading: boolean = true;

  @Element() el: HTMLElement;

  componentDidLoad() {
    initShadowMountPoints(this.el, 'stripe-express-checkout');

    const options = {
      paymentMethods: {
        googlePay: 'always',
        applePay: 'always',
        paypal: 'never',
      },
      layout: {
        overflow: 'never',
        maxColumns: 1,
      },
    };

    const elements = this.stripe.elements({
      mode: 'payment',
      amount: this.amountToPay,
      currency: this.currency,
    });

    const expressCheckoutElement = elements.create('expressCheckout', options);
    expressCheckoutElement.mount('#stripe-express-checkout-element');

    expressCheckoutElement.on('confirm', async () => {
      this.onConfirm(this.method, elements);
    });

    window.setTimeout(() => this.isLoading = false, 1200);
  }

  render() {
    return (
      <div class="overlay">
        {this.isLoading &&
          <rentware-spinner withOverlay={true} />
        }
        <slot name='stripe-express-checkout' />
        {!this.isLoading &&
          <a
            class="cancel"
             href='#'
             onClick={(e) => {
               e.preventDefault();
               this.onClose();
             }}>
            {t('payment.changeMethod')}
          </a>
        }
      </div>
    );
  }
}
